import {
  observableFetchClient,
  createAuthorizationHeaders,
  createContentTypeHeaders,
} from '@vp/common-api-utils';
import { getAuthHeaderAndShopperId } from '@vp/common-api-utils/authHelpers';
import { trackNRError, trackNREvent } from '../utils/newRelicTracker';
import {
  FULFILLMENT_PREFERENCE_FETCH_ERROR_NAME,
  FULFILLMENT_PREFERENCE_SAVE_ACTION_NAME,
  FULFILLMENT_PREFERENCE_SAVE_ERROR_NAME,
} from '../constants/newRelic';

const SHOPPER_PREFERENCES_BASE_URL = 'https://shop.orders.vpsvc.com';

export async function patchShopperFulfillmentPreferences(preference: boolean) {
  try {
    const { authHeader, shopperId } = getAuthHeaderAndShopperId();
    const response = await observableFetchClient({
      url: `${SHOPPER_PREFERENCES_BASE_URL}/shopper/${shopperId}/preferences/fulfillment`,
      method: 'PATCH',
      body: JSON.stringify({
        whiteLabel: preference,
      }),
      headers: new Headers({
        ...createContentTypeHeaders(),
        ...createAuthorizationHeaders(authHeader),
      }),
      timeout: 10000,
    }).then((res) => res.json());
    trackNREvent(FULFILLMENT_PREFERENCE_SAVE_ACTION_NAME);
    return response;
  } catch (error) {
    trackNRError(error as Error, {}, FULFILLMENT_PREFERENCE_SAVE_ERROR_NAME);
    throw error; // So react-query needs this to know if we failed
  }
}

export async function getShopperFulfillmentPreferences() {
  try {
    const { authHeader, shopperId } = getAuthHeaderAndShopperId();
    const response = await observableFetchClient({
      url: `${SHOPPER_PREFERENCES_BASE_URL}/shopper/${shopperId}/preferences/fulfillment`,
      method: 'GET',
      headers: createAuthorizationHeaders(authHeader),
      timeout: 10000,
    }).then((res) => res.json());
    return response;
  } catch (error) {
    trackNRError(error as Error, {}, FULFILLMENT_PREFERENCE_FETCH_ERROR_NAME);
    throw error; // So react-query needs this to know if we failed
  }
}
